import { render, staticRenderFns } from "./FrameMenuMobile.vue?vue&type=template&id=5cc5fb92&scoped=true"
import script from "./FrameMenuMobile.vue?vue&type=script&lang=js"
export * from "./FrameMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./FrameMenuMobile.vue?vue&type=style&index=0&id=5cc5fb92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc5fb92",
  null
  
)

export default component.exports